<ng-container *ngIf="isSmallScreen; else largeScreen">
    <dx-data-grid id="gridContainer" class="p-1"
    [dataSource]="TSvc.trashMachinePartInfoDataSource"
    [showBorders]="true"
    [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    dataRowTemplate="dataRowTemplateName">

    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="PartType" [caption]="'part-type' | translateWithFallback" dataType="string" width="45%"></dxi-column>
    <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"></dxi-column>

    <tr *dxTemplate="let partInfo of 'dataRowTemplateName'" role="row" [ngClass]="{ 'dx-row-alt': partInfo.rowIndex % 2 === 0 }">
      <td colspan="2">
        <table width="100%" >
          <tr class="main-row" role="row">
            <td role="gridcell" width="10%">
              <dx-button stylingMode="text" (click)="show(partInfo.rowIndex)">
                <fa-icon *ngIf="!isShowed[partInfo.rowIndex]" [icon]="faAngleRight"></fa-icon>
                <fa-icon *ngIf="isShowed[partInfo.rowIndex]" [icon]="faAngleDown"></fa-icon>
              </dx-button>
            </td>
            <td role="gridcell" width="45%">{{ partInfo.data.PartType }}</td>
            <td role="gridcell" width="45%">{{ partInfo.data.Name }}</td>
          </tr>
          <tr *ngIf="isShowed[partInfo.rowIndex]">
            <td colspan="3">
              <table width="100%">
                <tr class="main-row" role="row">
                  <td role="gridcell" width="45%">{{ partInfo.data.Name }}</td>
                  <td role="gridcell" width="45%">{{ partInfo.data.PartType }}</td>
                </tr>
                <tr role="row" *ngIf="partInfo.data.DeviceModel">
                  <td role="gridcell">{{'model' | translateWithFallback}} <span class="notes font-12">{{ partInfo.data.DeviceModel }}</span></td>
                </tr>
                <tr role="row" *ngIf="partInfo.data.FirmwareVersion">
                  <td role="gridcell" colspan="2">{{'fv' | translateWithFallback}} <span class="notes font-12">{{ partInfo.data.FirmwareVersion }}</span></td>
                </tr>
                <tr role="row">
                  <td role="gridcell" colspan="2">{{'created' | translateWithFallback}} <span class="notes font-12">{{ partInfo.data.Created | date: 'dd/MM/yyyy hh.mm.ss' }}</span></td>
                </tr>
                <tr class="notes-row" role="row" *ngIf="partInfo.data.Status">
                  <td role="gridcell" colspan="2">{{ partInfo.data.Status }}</td>
                </tr>
                <tr role="row">
                  <td role="gridcell" colspan="2">{{'modified' | translateWithFallback}} <span class="notes font-12">{{ partInfo.data.Modified | date: 'dd/MM/yyyy hh.mm.ss' }}</span></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-container>

<ng-template #largeScreen>
    <dx-data-grid 
        id="gridPartsContainer"
        class="p-1"
        [dataSource]="TSvc.trashMachinePartInfoDataSource"
        [showBorders]="true" 
        [remoteOperations]="true"
        [rowAlternationEnabled]="true"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [columnHidingEnabled]="true"
        >

        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxi-column dataField="PartType" [caption]="'part-type' | translateWithFallback" dataType="string" [hidingPriority]="6"> </dxi-column>
        <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"> </dxi-column>
        <dxi-column dataField="FirmwareVersion" [caption]="'firmware-version' | translateWithFallback" dataType="string" [hidingPriority]="5"> </dxi-column>
        <dxi-column dataField="DeviceModel" dataType="string" [caption]="'model' | translateWithFallback" [hidingPriority]="4"></dxi-column>
        <dxi-column dataField="Version" [caption]="'version' | translateWithFallback" dataType="string" [hidingPriority]="3"> </dxi-column>
        <dxi-column dataField="Created" [caption]="'created' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="2"></dxi-column>
        <dxi-column dataField="Modified" [caption]="'modified' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="1"></dxi-column>
        <dxi-column dataField="Status" [caption]="'status' | translateWithFallback" dataType="string" [hidingPriority]="0"> </dxi-column>

        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
        <dxo-paging [pageSize]="25"> </dxo-paging>
        <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true" [showPageSizeSelector]="true"
            [allowedPageSizes]="[10, 25, 50, 100]">
        </dxo-pager>
    </dx-data-grid>
</ng-template>
